import { addMinutes, isAfter, parseJSON } from "date-fns";
import Dashboard, {
	IOverviewChannel
} from "../../../services/api/Dashboard";

interface ICacheInfo {
	year: number;
	month: number;
	period: 'MONTH' | 'YTD';
	expirationDate: Date;
	channel: IOverviewChannel;
}

interface ICacheChannelOverviewHandler {
  overview: IOverviewChannel;
  ytdOverview: IOverviewChannel;
}

export const getOverviewChannels = async (year: number, month: number): Promise<ICacheChannelOverviewHandler> => {
  let overview = {} as IOverviewChannel;
  let ytdOverview = {} as IOverviewChannel;

  let storage: Array<ICacheInfo> = [];
  const getStorage = sessionStorage.getItem("overview-channel");
  const expirationDate = addMinutes(new Date(), 5);
  const now = new Date();


  if(getStorage){
    storage = JSON.parse(getStorage) as Array<ICacheInfo>;
    let cachedMonth = storage.filter(x => 
      x.year === year 
      && x.month === month
    );

    if(cachedMonth.length > 0 && isAfter(now, parseJSON(cachedMonth[0].expirationDate))){
      cachedMonth = [];
      storage = storage.filter(x => x.month !== month || x.year !== year);
    }

    if(cachedMonth.length === 0){
      overview = await Dashboard.GetChannel("LATAM", year, month);
      ytdOverview = await Dashboard.GetYTDChannel("LATAM", year, month);

      const overviewMonth: ICacheInfo = {
        year,
        month,
        period: 'MONTH',
        expirationDate,
        channel: overview
      };

      const overviewYtd: ICacheInfo = {
        year,
        month,
        period: 'YTD',
        expirationDate,
        channel: ytdOverview
      };

      storage.push(overviewMonth);
      storage.push(overviewYtd);

      sessionStorage.setItem("overview-channel", JSON.stringify(storage));

    }else {

      const overviewMonth = cachedMonth.find(x => x.period === 'MONTH') as ICacheInfo;
      const overviewYTD = cachedMonth.find(x => x.period === 'YTD') as ICacheInfo;

      storage.push(overviewMonth);
      storage.push(overviewYTD);

      overview = overviewMonth.channel;
      ytdOverview = overviewYTD.channel;

    }

  }else {
    overview = await Dashboard.GetChannel("LATAM", year, month);
    ytdOverview = await Dashboard.GetYTDChannel("LATAM", year, month);

    storage.push({
      year: year,
      month: month,
      period: 'MONTH',
      expirationDate,
      channel: overview
    });

    storage.push({
      year: year,
      month: month,
      period: 'YTD',
      expirationDate,
      channel: ytdOverview
    });

    sessionStorage.setItem("overview-channel", JSON.stringify(storage));
  }

  return {
    overview,
    ytdOverview
  }
}